import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { ELoginTypes } from '@ui-components/models';

@Injectable({
  providedIn: 'root'
})
export class AsicAuthenticationService {

  constructor(private http: HttpClient) { }

  forgotPassword
    (payLoad: {
      emailTemplateId: string, newPathname: string, forgotPasswordBy: ELoginTypes,
      forgotPasswordByValue: string, forgotPasswordByPropertyName: string
    }) {
    return this.http.post(`/Account/ForgotPassword`, {
      EmailTemplateId: payLoad.emailTemplateId,
      Host: window.location.origin + '/' + payLoad.newPathname,
      ForgotPasswordBy: payLoad.forgotPasswordBy,
      ForgotPasswordByValue: payLoad.forgotPasswordByValue,
      ForgotPasswordByPropertyName: payLoad.forgotPasswordByPropertyName
    });

  }

  checkUserOptionValidation(validationArray) {
    return this.http.post('/Account/CheckUserOptionValidation', validationArray);
  }

  signup(signUpObject) {
    return this.http.post('/Account/register', signUpObject);
  }

  sendCode(data, requestOptions) {
    return this.http.post(`/Account/SendCode`, data, requestOptions)
  }

  VerifyCode(data, requestOptions) {
    return this.http.post(`/Account/VerifyCode`, data, requestOptions)
  }

  ResetPassword(data) {
    return this.http.post(`/Account/ChangePassword`, data);
  }

  GetUserByUserOption(userOptionValue: string, userOptionKey: string) {
    return this.http.get(`/Account/GetUserByUserOption/${userOptionValue}/${userOptionKey}`)
  }

  EditProfile(formData) {
    return this.http.put(`/Account/EditProfile`, formData);
  }

}
